import { Account, AccountStatus } from '@/common/types'

/**
 * Checks if an account is fully active and ready to trade.
 * @param account - The account to check
 * @returns True if accountStatus is ACTIVE
 */
export function isActiveAccount(account: Account): boolean {
    return account.accountStatus === AccountStatus.ACTIVE
}
